import { render, staticRenderFns } from "./variant2.vue?vue&type=template&id=ac4a21f0&scoped=true"
import script from "./variant2.vue?vue&type=script&lang=js"
export * from "./variant2.vue?vue&type=script&lang=js"
import style0 from "./variant2.vue?vue&type=style&index=0&id=ac4a21f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4a21f0",
  null
  
)

export default component.exports